export default __webpack_public_path__ + "static/media/notfound.22bff5ce.jpg";